import React from "react";

export default function CancellationPolicy() {
  // const sections = [
  //   {
  //     title: "1. General Rules",
  //     content: (
  //       <ul style={{ color: "#6C757D", paddingLeft: "20px" }}>
  //         <li>A cancellation fee may apply when a confirmed ride is cancelled after allocation.</li>
  //         <li>Charges are calculated based on demand, distance, Rider arrival, and waiting time.</li>
  //         <li>INRYDE may waive charges for verified safety-related or operational issues.</li>
  //       </ul>
  //     ),
  //   },
  //   {
  //     title: "2. Customer Ride Cancellation",
  //     content: (
  //       <ul style={{ color: "#6C757D", paddingLeft: "20px" }}>
  //         <li>Cancellation fees apply when the Rider has reached or is close to the pickup location.</li>
  //         <li>Charges apply if the Rider has waited beyond the allowed free waiting time.</li>
  //         <li>Fee may apply if Customer enters the wrong pickup location or becomes unreachable.</li>
  //         <li>Repeated cancellations within a short time may lead to penalties.</li>
  //         <br />
  //         <strong>No cancellation fee will be charged if:</strong>
  //         <li>Rider asks for extra fare or offline payment.</li>
  //         <li>Rider behaves rudely or shows unsafe driving behavior.</li>
  //         <li>Vehicle is unfit, dirty, damaged, or mismatched from the app.</li>
  //         <li>Rider does not move towards pickup or delays intentionally.</li>
  //         <li>Customer cancels due to a verified safety concern or Rider misuse.</li>
  //       </ul>
  //     ),
  //   },
  //   {
  //     title: "3. Rider Ride Cancellation",
  //     content: (
  //       <ul style={{ color: "#6C757D", paddingLeft: "20px" }}>
  //         <li>Riders may cancel without penalty if the Customer requests illegal transport.</li>
  //         <li>Rider may cancel if the Customer misbehaves or demands a free ride.</li>
  //         <li>Rider can cancel if the pickup location poses a safety concern.</li>
  //         <br />
  //         <strong>Rider may be penalized or suspended for:</strong>
  //         <li>Frequent cancellations without valid reason.</li>
  //         <li>Cancelling to demand higher fare or offline payment.</li>
  //         <li>Not arriving at pickup intentionally or delaying response.</li>
  //         <li>Unsafe behavior, misconduct, or harassment.</li>
  //       </ul>
  //     ),
  //   },
  //   {
  //     title: "4. Waiting Time & Charges",
  //     content: (
  //       <ul style={{ color: "#6C757D", paddingLeft: "20px" }}>
  //         <li>Free waiting time will be displayed in the INRYDE app.</li>
  //         <li>Additional waiting charges may apply after the free waiting period ends.</li>
  //         <li>If Customer does not show within the waiting time, trip may auto-cancel with charges.</li>
  //       </ul>
  //     ),
  //   },
  //   {
  //     title: "5. Cancellations Due to Technical or Operational Issues",
  //     content:
  //       "In case of app errors, Rider GPS glitches, traffic closures, or system outages, no cancellation fee will be imposed on either party.",
  //   },
  //   {
  //     title: "6. Policy Misuse",
  //     content:
  //       "INRYDE may block accounts and recover penalties for fraudulent cancellations, fake bookings, GPS tampering, or scam activities.",
  //   },
  //   {
  //     title: "7. Contact Support",
  //     content: (
  //       <p style={{ color: "#6C757D" }}>
  //         Email:{" "}
  //         <a
  //           href="mailto:support@inryde.in"
  //           style={{ color: "#E63946", textDecoration: "underline" }}
  //         >
  //           support@inryde.in
  //         </a>
  //         <br />
  //         Phone: <strong>9866398548</strong>
  //         <br />
  //         Office: 2nd floor, D.no 50-1-40, Near ASR Statue, Seethammadhara, Visakhapatnam – 530013
  //       </p>
  //     ),
  //   },
  // ];

  const sections = [
  {
    title: "1. Order Cancellation Policy",
    content: (
      <ul style={{ color: '#6C757D', paddingLeft: '20px' }}>
        <li>Cancellations are allowed only if the request is made within 7 days from placing the order.</li>
        <li>Cancellation may not be accepted if the order has already been processed or shipped by the vendor/merchant.</li>
        <li>Cancellations are not accepted for perishable items.</li>
        <li>Cancellation due to poor product quality is allowed if the claim is valid.</li>
        <li>Damaged or defective product cancellation requests must be reported within 7 days of delivery.</li>
        <li>If the delivered product does not match what was shown/expected, it must be reported within 7 days.</li>
      </ul>
    ),
  },
];


  return (
    <div
      style={{
        backgroundColor: "#F8F9FA",
        padding: "100px 20px",
        fontFamily: "'Inter', sans-serif",
        color: "#1C1C1C",
        lineHeight: "1.8",
      }}
    >
      <h1
        style={{
          fontFamily: "'Poppins', sans-serif",
          fontSize: "3rem",
          background: "linear-gradient(90deg, #E63946, #FFC300)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          marginBottom: "50px",
          textAlign: "center",
        }}
      >
        Cancellation Policy
      </h1>

      {sections.map((section, index) => (
        <div
          key={index}
          style={{
            backgroundColor: "#FFFFFF",
            padding: "30px",
            borderRadius: "15px",
            boxShadow: "0 4px 15px rgba(0,0,0,0.05)",
            marginBottom: "30px",
          }}
        >
          <h2
            style={{
              fontFamily: "'Poppins', sans-serif",
              color: "#E63946",
              paddingBottom: "10px",
              marginBottom: "20px",
            }}
          >
            {section.title}
          </h2>
          {section.content}
        </div>
      ))}
    </div>
  );
}
